var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMidInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#383864",
    d: "M8.305 2.828L11.133 0H0v11.133l2.828-2.828V2.828zM7.695 13.172L4.867 16H16V4.867l-2.828 2.828v5.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#565691",
    d: "M13.371 0L0 13.371v2.63h2.629L16 2.628V0z"
  }))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/roles/mid-inactive.svg";
export { SvgMidInactive as ReactComponent };